import * as React from "react";
const TopArrow = (props) => (

  <svg
    width={22}
    height={12}
    viewBox="0 0 22 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.798 12L7.71233e-07 10.2153L9.79907 0.494454C9.95609 0.337759 10.1428 0.213404 10.3485 0.128546C10.5541 0.0436871 10.7747 8.47487e-07 10.9975 8.30669e-07C11.2202 8.13851e-07 11.4408 0.0436871 11.6464 0.128545C11.8521 0.213404 12.0388 0.337759 12.1958 0.494454L22 10.2153L20.202 11.9983L11 2.87462L1.798 12Z"
      fill="#EEEBE5"
    />
  </svg>


);
export default TopArrow;
